<div class="container-fluid">
  <div class="row">
    <div class="col">
      <app-title-content-widget [title]="'My Vendors'">
        <ng-template #titleContentPanel>
          <div
            class="inner-panel cursor-select"
            (click)="navigateToVendorSearchPage()"
          >
            <div class="row h-100 justify-content-center align-items-center">
              <div class="col-auto">
                <i class="lh-0 bi bi-wrench fs-220"></i>
              </div>
            </div>
          </div>
        </ng-template>
      </app-title-content-widget>
    </div>
  </div>
</div>
